const formatReportBalance = (balance: number) => {
  let balanceValue = '0';

  if (balance?.toString()) {
    const balanceParts: string[] = balance?.toString().split('.');

    const part = balanceParts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    const balanceSecondPart = balanceParts[1] ? balanceParts[1] : '00';
    balanceValue = `${part}.${balanceSecondPart}`;
  }

  return balanceValue;
};

export default formatReportBalance;
